import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useUDData } from '@udemy/ud-data';
import { getBrowseURL } from '../../../get-browse-url';
import { useUfbModels } from '../../../hooks/use-ufb-models';
import { MobileNavL1Nav, MobileNavSection, MobileNavItem } from '../../../mobile/mobile-nav/mobile-nav.react-component';
export const MobileCustomCategoryNav = observer(() => {
  const {
    customCategoriesModel
  } = useUfbModels();
  const udData = useUDData();
  useEffect(() => {
    customCategoriesModel.loadChildren();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (customCategoriesModel.children.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(MobileNavL1Nav, {
    id: "header-toggle-side-nav-custom-categories"
  }, /*#__PURE__*/React.createElement(MobileNavSection, null, customCategoriesModel.children.map(category => /*#__PURE__*/React.createElement(MobileNavItem, Object.assign({
    key: category.id
  }, category.absolute_url !== 'none' && {
    href: getBrowseURL(category.absolute_url, udData.Config.brand.has_organization)
  }), category.title))));
});
//# sourceMappingURL=mobile-custom-category-nav.react-component.js.map